import React from 'react';
import { getIntermediateConfig, isImageMediaUrl, renderWelcomeHtml } from './intermediateWelcome';

const bandStyle = {
  width: '100%',
  minHeight: 0,
  boxSizing: 'border-box',
};

function WelcomeMedia({ mediaUrl }) {
  if (!mediaUrl) {
    return <div style={{ width: '100%', height: '100%', background: '#F4F6F8' }} />;
  }

  if (isImageMediaUrl(mediaUrl)) {
    return (
      <img
        src={mediaUrl}
        alt="Welcome"
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    );
  }

  return (
    <video
      src={mediaUrl}
      autoPlay
      loop
      muted
      playsInline
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', background: '#111' }}
    />
  );
}

export default function IntermediateWelcomePanel({ customization, onMinimize, onStart }) {
  const intermediate = getIntermediateConfig(customization);
  const buttonColor = customization.sendIconColor || '#1976d2';
  const controlColor = customization.chatControlIconColor || '#555555';

  const handlePanelClick = (event) => {
    if (event.target.closest('[data-welcome-minimize]')) return;
    const link = event.target.closest('a');
    if (link) event.preventDefault();
    if (onStart) onStart();
  };

  return (
    <div
      onClick={handlePanelClick}
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        overflow: 'hidden',
        boxSizing: 'border-box',
        cursor: 'pointer',
      }}
    >
      <button
        type="button"
        data-welcome-minimize=""
        onClick={(event) => {
          event.stopPropagation();
          if (onMinimize) onMinimize();
        }}
        aria-label="Minimize chat"
        style={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 2,
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: '1px solid #ddd',
          background: '#fff',
          color: controlColor,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
          fontSize: 18,
          lineHeight: 1,
          padding: 0,
        }}
      >
        −
      </button>

      <div style={{ ...bandStyle, height: '60%', overflow: 'hidden', background: '#F4F6F8' }}>
        <WelcomeMedia mediaUrl={intermediate.mediaUrl} />
      </div>

      <div
        className="intermediate-welcome-html"
        style={{
          ...bandStyle,
          height: '30%',
          overflowY: 'auto',
          padding: '12px 16px',
          textAlign: 'left',
          color: '#222',
          fontFamily: 'system-ui, Inter, Arial, sans-serif',
          fontSize: 14,
          lineHeight: 1.5,
        }}
        dangerouslySetInnerHTML={{ __html: renderWelcomeHtml(intermediate.html) }}
      />

      <div
        style={{
          ...bandStyle,
          height: '10%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 16px 10px',
        }}
      >
        <button
          type="button"
          style={{
            maxWidth: '100%',
            border: 'none',
            borderRadius: 8,
            background: buttonColor,
            color: '#fff',
            fontWeight: 600,
            fontSize: 14,
            lineHeight: 1.2,
            padding: '8px 16px',
            cursor: 'pointer',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {intermediate.buttonTitle}
        </button>
      </div>
      <style>{`
        .intermediate-welcome-html h1,
        .intermediate-welcome-html h2,
        .intermediate-welcome-html h3,
        .intermediate-welcome-html h4 { margin: 0 0 8px; line-height: 1.3; }
        .intermediate-welcome-html h1 { font-size: 22px; }
        .intermediate-welcome-html h2 { font-size: 18px; }
        .intermediate-welcome-html h3, .intermediate-welcome-html h4 { font-size: 16px; }
        .intermediate-welcome-html p { margin: 0 0 8px; }
        .intermediate-welcome-html p:last-child { margin-bottom: 0; }
        .intermediate-welcome-html ul, .intermediate-welcome-html ol { margin: 0 0 8px; padding-left: 18px; }
        .intermediate-welcome-html a { color: #1976d2; }
        .intermediate-welcome-html img { max-width: 100%; height: auto; }
      `}</style>
    </div>
  );
}
